import ButtonSmallMixin from './mixins/button-small-mixin.js';
import ButtonTextMixin from './mixins/button-text-mixin.js';
import TpButton from './tp-button.js';

class TpButtonTextSmall extends
  ButtonSmallMixin(
  ButtonTextMixin(
    TpButton
  )) {}

export default TpButtonTextSmall;


